import {LitElement} from 'lit';

export class VscElement extends LitElement {}
